import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuthStore } from '../../stores/authStore';

/**
 * Protects admin routes — checks for valid owner session.
 * Redirects to login if unauthenticated. Preserves redirect path.
 */
export function RequireAdmin({ children }) {
  const { user, isOwner, loading, initialize } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    initialize();
  }, [initialize]);

  // Still loading session
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ui-background">
        <div className="text-center">
          <Loader2 size={36} className="text-brand-red animate-spin mx-auto mb-3" />
          <p className="text-sm font-medium text-brand-gray">Loading...</p>
        </div>
      </div>
    );
  }

  // Not authenticated or not the owner
  if (!user || !isOwner) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  return children;
}
